var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.34374 1.01953V3.88406H2.45408C0.981669 3.88406 0.490865 4.36148 0.490865 5.79374V11.5228H2.45408V9.61311C2.45408 8.18085 2.94489 7.70343 4.4173 7.70343H8.34374V10.568L14.2334 5.79374L8.34374 1.01953Z",
    fill: "url(#paint0_linear_6999_47588)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.85288 0V3.40642H2.45402C1.69063 3.40642 1.02551 3.52402 0.573208 3.964C0.120901 4.40397 0 5.05095 0 5.79353V12H2.94483V9.6129C2.94483 8.92321 3.06933 8.61534 3.23053 8.45854C3.39173 8.30174 3.70823 8.18063 4.41724 8.18063H7.85288V11.5871L15 5.79353L7.85288 0ZM13.4667 5.79353L8.83449 9.54842V7.22579H4.41724C3.65385 7.22579 2.98873 7.34339 2.53643 7.78337C2.08412 8.22334 1.96322 8.87031 1.96322 9.6129V11.0452H0.98161V5.79353C0.98161 5.10384 1.10611 4.79598 1.26731 4.63917C1.42851 4.48237 1.74501 4.36126 2.45402 4.36126H8.83449V2.03863L13.4667 5.79353Z",
    fill: "#626262"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6999_47588",
    x1: 7.36213,
    y1: 1.01953,
    x2: 7.36213,
    y2: 11.5228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4BBC9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.d3eba18bf35ed26b9d06f1d222cb7216.svg";
export { ForwardRef as ReactComponent };